var _style, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNtrnIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 318.3 318.3",
    style: {
      enableBackground: "new 0 0 318.3 318.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:#D6D6D6;stroke-miterlimit:10;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 159.2,
    cy: 159.2,
    r: 158.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.7,59.7H73.7l54.3,64.1c8.3-7.3,19.2-11.7,31.1-11.7c26,0,47.1,21.1,47.1,47.1c0,11.7-4.3,22.4-11.3,30.7 l63.7,55.1v13.7V59.7z M234.8,258.7l-50.5-59.6c-7.3,4.6-15.9,7.2-25.1,7.2c-26,0-47.1-21.1-47.1-47.1c0-9.2,2.6-17.7,7.1-25 L59.7,82.9v175.8H234.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNtrnIcon);
export default __webpack_public_path__ + "static/media/ntrn_icon.db01f6c634540dd17258046730612afb.svg";
export { ForwardRef as ReactComponent };